/* ==========================================================================
   Mega Menu behaviour — Dawn v13 (desktop only)
   Hover reveal is handled in CSS. This adds keyboard support (Escape to close,
   aria-expanded syncing). Mobile is handled entirely by Dawn's own drawer, so
   there is no mobile logic here.
   ========================================================================== */
(function () {
  'use strict';

  function initMegaMenu(root) {
    const items = root.querySelectorAll('.mega-menu__item--has-panel');

    items.forEach((item) => {
      const trigger = item.querySelector('.mega-menu__top-link');
      if (!trigger) return;

      // Sync aria-expanded with hover/focus for assistive tech
      item.addEventListener('mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
      item.addEventListener('mouseleave', () => trigger.setAttribute('aria-expanded', 'false'));
      item.addEventListener('focusin', () => trigger.setAttribute('aria-expanded', 'true'));
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) trigger.setAttribute('aria-expanded', 'false');
      });

      // Escape closes the panel and returns focus to the trigger
      item.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.blur();
          trigger.focus();
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.mega-menu').forEach(initMegaMenu);
  });
})();
